import { memo } from 'react';

import { PopupManager, Toast } from '@gem/popups';

import { DetailedFeedback } from './DetailedFeedback/DetailedFeedback';
import { GetParametersManager } from './GetParametersManager/GetParametersManager';
import { OfflineToast } from './OfflineToast/OfflineToast';
import RequestPermission from './RequestPermission';
import { SignInDeviceRequestsToast } from './SignInDeviceRequestsToast/SignInDeviceRequestsToast';
import { StarsFeedback } from './StarsFeedback/StarsFeedback';

export const Popups = memo(() => {
  return (
    <>
      <GetParametersManager />
      <PopupManager />
      <RequestPermission />
      <Toast />
      <StarsFeedback />
      <DetailedFeedback />
      <OfflineToast />
      <SignInDeviceRequestsToast />
    </>
  );
});
